import { useState } from "react";
import "../styles/App.scss";
import { Col, Row, Container, Button } from "react-bootstrap";
import { AnimatePresence, motion } from "framer-motion";

import data from "../data/data";

function TestPage(props) {
    const handleAnswer = (answer) => {
        const newTestResults = [...props.testResults];
        newTestResults[data[props.currentQuestion].answer[answer].dimetion[0]][
            data[props.currentQuestion].answer[answer].dimetion[1]
        ] += 1;
        props.setTestResults(newTestResults);
        // console.log("New test results", newTestResults);
        if (props.currentQuestion < data.length - 1) {
            props.setCurrentQuestion(() => props.currentQuestion + 1);
        } else {
            props.setCurrentPage(() => props.currentPage + 1); // Go to the result page
        }
    };

    return (
        <AnimatePresence mode="popLayout">

                <motion.div
                    className="background-image"
                    key="background"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.4 }}
                    style={{
                        backgroundImage: `url(${
                            data[props.currentQuestion].backgroundImage
                        })`,
                    }}
                >
                    <Container>
                        <Row className="justify-content-md-center title-row">
                            <Col>
                                    <motion.h1
                                        key={props.currentQuestion + "-question"}
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <p>{data[props.currentQuestion].question}</p>
                                    </motion.h1>
                            </Col>
                        </Row>
                        <Row className="justify-content-md-center">
                            <Col>
                                <AnimatePresence mode="popLayout">
                                    <motion.img
                                        key={
                                            props.currentQuestion + "-leftImage"
                                        }
                                        src={
                                            data[props.currentQuestion]
                                                .leftImage
                                        }
                                        width={
                                            data[props.currentQuestion]
                                                .leftImageWidth
                                        }
                                        height={
                                            data[props.currentQuestion]
                                                .leftImageHeight
                                        }
                                        style={{
                                            translateX: `${
                                                data[props.currentQuestion]
                                                    .leftImageWidth +
                                                    data[props.currentQuestion]
                                                        .rightImageWidth >
                                                440
                                                    ? (data[
                                                          props.currentQuestion
                                                      ].leftImageWidth +
                                                          data[
                                                              props
                                                                  .currentQuestion
                                                          ].rightImageWidth -
                                                          440) /
                                                      2
                                                    : 0
                                            }px`,
                                        }}
                                        initial={{ opacity: 1, x: -40 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        exit={{ opacity: 0, x: -40 }}
                                        transition={{ duration: 0.8 }}
                                    />
                                </AnimatePresence>
                            </Col>
                            <Col>
                                <AnimatePresence mode="popLayout">
                                    <motion.img
                                        key={
                                            props.currentQuestion +
                                            "-rightImage"
                                        }
                                        src={
                                            data[props.currentQuestion]
                                                .rightImage
                                        }
                                        width={
                                            data[props.currentQuestion]
                                                .rightImageWidth
                                        }
                                        height={
                                            data[props.currentQuestion]
                                                .rightImageHeight
                                        }
                                        initial={{ opacity: 1, x: 40 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        exit={{ opacity: 0, x: 40 }}
                                        style={{
                                            translateX: `-${
                                                data[props.currentQuestion]
                                                    .leftImageWidth +
                                                    data[props.currentQuestion]
                                                        .rightImageWidth >
                                                440
                                                    ? (data[
                                                          props.currentQuestion
                                                      ].leftImageWidth +
                                                          data[
                                                              props
                                                                  .currentQuestion
                                                          ].rightImageWidth -
                                                          440) /
                                                      2
                                                    : 0
                                            }px`,
                                        }}
                                        transition={{ duration: 0.8 }}
                                    />
                                </AnimatePresence>
                            </Col>
                        </Row>
                        <Row className="answer">
                            <Col>
                                <Button
                                    className="answer-button"
                                    variant="primary"
                                    size="lg"
                                    onClick={() => handleAnswer(0)}
                                    style={{
                                        color: data[props.currentQuestion][
                                            "answer-color"
                                        ],
                                        backgroundColor:
                                            data[props.currentQuestion][
                                                "answer-backgroundColor"
                                            ],
                                    }}
                                >
                                    <motion.span
                                        key={props.currentQuestion + "-answer"}
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.4 }}>
                                        {data[props.currentQuestion].answer[0].text}
                                    </motion.span>
                                </Button>
                            </Col>
                        </Row>
                        <Row className="answer">
                            <Col>
                                <motion.div kev={props.currentQuestion + "-answer-button-2"}
                                initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.4 }}>
                                    <Button
                                    className="answer-button"
                                    variant="primary"
                                    size="lg"
                                    onClick={() => handleAnswer(1)}
                                    style={{
                                        color: data[props.currentQuestion][
                                            "answer-color"
                                        ],
                                        backgroundColor:
                                            data[props.currentQuestion][
                                                "answer-backgroundColor"
                                            ],
                                    }}
                                >
                                    <motion.span
                                        key={props.currentQuestion + "-answer-2"}
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.4 }}>
                                        {data[props.currentQuestion].answer[1].text}
                                    </motion.span>
                                </Button>
                                </motion.div>
                            </Col>
                        </Row>
                    </Container>
                </motion.div>
        </AnimatePresence>
    );
}
export default TestPage;
